export default __webpack_public_path__ + "static/vm-6437e4e5a400c6eff1c23ead4d549b0a.png";